import 'css-chunksrc/client/pages/workloadPage/table/projectsDetail/projectRow/styles.scss';export default {
  "row": "_row_1eifj_1",
  "projectCell": "_projectCell_1eifj_6",
  "zone": "_zone_1eifj_22",
  "icon": "_icon_1eifj_29",
  "name": "_name_1eifj_36",
  "clickable": "_clickable_1eifj_44"
};